// MARK: React
import * as React from "react";
import "./style.scss";

// Mobx
import { observer } from "mobx-react";
import { routerStore } from "../../stores/_rootStore";

// Resources
import strings from "../../resources/strings";
import { Button } from "@material-ui/core";

interface IProps {
	onSave: () => void;
}

@observer
export default class SaveAndCancelFormButtons extends React.Component<IProps> {
	public render() {
		return (
			<div className="buttonsContainer">
			<Button
				onClick={() => this.props.onSave()}
				style={{ backgroundColor: "#0081B0", color: "white" }}
			>
				{strings.hotel.edit.buttons.save}
			</Button>
			<Button
				onClick={() => routerStore.push("/dashboard/")}
			>
				{strings.hotel.edit.buttons.exit}
			</Button>
		</div>
		);
	}
}
